module.exports = __webpack_public_path__ + "media/images/icon-arrow-right-purpleHeart-b0359afac4e23bea65d03fbcf5f48acf.svg";